import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["ratingStars", "label"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { StyledLabeledRatingStars } from './LabeledRatingStars.styles';

/**
 * Displays a `RatingStars` component with
 * an accompanying text label.
 *
 * @related ['TextButton']
 * @since 8.4.0
 */
export var LabeledRatingStars = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var ratingStars = _ref.ratingStars,
    label = _ref.label,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledLabeledRatingStars, _extends({}, rest, {
    ref: forwardedRef
  }), ratingStars, label);
});
LabeledRatingStars.displayName = 'LabeledRatingStars';
LabeledRatingStars.propTypes = {
  /** The `RatingStars` component. */
  ratingStars: PropTypes.node.isRequired,
  /**
   * The label to display next to the Rating Stars. Usually, this will be a `TextButton`.
   */
  label: PropTypes.node
};
LabeledRatingStars.defaultProps = {
  label: undefined
};